import React, { useState } from 'react';
import Slider from 'react-slick';
import PageHeader from '../components/PageHeader';
import t1 from '../assets/img/testimonial-1.jpg';
import t2 from '../assets/img/testimonial-2.jpg';
import t3 from '../assets/img/testimonial-3.jpg';
import t4 from '../assets/img/testimonial-4.jpg';
import logo1 from '../assets/img/com-logo-1.jpg';
import logo2 from '../assets/img/com-logo-2.jpg';
import logo3 from '../assets/img/com-logo-3.jpg';
import logo4 from '../assets/img/com-logo-4.jpg';
import logo5 from '../assets/img/com-logo-5.jpg';

const testimonials = [
  {
    img: t1, name: 'Sarah Johnson', role: 'UX Designer', company: 'Google', rating: 5,
    text: 'JobEntry completely transformed my job search. Within 2 weeks I had 6 interviews lined up and landed my dream role at Google. The AI matching is incredibly accurate!',
    tag: 'Got Hired in 2 Weeks',
  },
  {
    img: t2, name: 'Michael Chen', role: 'CTO', company: 'TechCorp', rating: 5,
    text: 'As a hiring manager, I\'ve tried every platform out there. JobEntry gives us the highest quality candidates with the least effort. Our time-to-hire dropped by 60%.',
    tag: '60% Faster Hiring',
  },
  {
    img: t3, name: 'Priya Sharma', role: 'Data Analyst', company: 'Amazon', rating: 5,
    text: 'The one-click apply and smart filters saved me hours every week. I got 5 interview calls in the first week. Absolutely the best job portal I\'ve ever used.',
    tag: '5 Interviews in Week 1',
  },
  {
    img: t4, name: 'James Williams', role: 'Product Manager', company: 'Meta', rating: 5,
    text: 'Clean interface, verified listings, and real companies. JobEntry is the only platform where I never felt like I was wasting my time. Highly recommend to everyone.',
    tag: 'Verified Listings',
  },
  {
    img: t1, name: 'Emily Davis', role: 'Frontend Developer', company: 'Spotify', rating: 5,
    text: 'I was skeptical at first but JobEntry proved me wrong. The job recommendations were so relevant and the application process was seamless. Got hired in 3 weeks!',
    tag: 'Hired in 3 Weeks',
  },
  {
    img: t2, name: 'David Kim', role: 'HR Director', company: 'Netflix', rating: 5,
    text: 'We\'ve been using JobEntry for all our hiring needs for over a year. The quality of applicants is consistently high and the platform keeps getting better.',
    tag: '1 Year of Success',
  },
];

const stats = [
  { num: '98%', label: 'Satisfaction Rate' },
  { num: '120K+', label: 'Success Stories' },
  { num: '4.9/5', label: 'Average Rating' },
  { num: '35K+', label: 'Jobs Filled' },
];

const companies = [logo1, logo2, logo3, logo4, logo5];

const filters = ['All', 'Job Seekers', 'Employers'];

export default function Testimonial() {
  const [active, setActive] = useState(0);
  const [featured, setFeatured] = useState(0);

  const sliderSettings = {
    dots: false, infinite: true, speed: 600,
    slidesToShow: 1, slidesToScroll: 1,
    autoplay: true, autoplaySpeed: 5000, arrows: false,
  };

  const gridSettings = {
    dots: true, infinite: true, speed: 500,
    slidesToShow: 3, slidesToScroll: 1,
    autoplay: true, autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      <PageHeader title="Testimonials" breadcrumb="Testimonials" />

      {/* ── Stats Bar ── */}
      <section className="testi-stats-bar">
        <div className="container">
          <div className="testi-stats-grid">
            {stats.map((s, i) => (
              <div className="testi-stat-item" key={i}>
                <span className="testi-stat-num">{s.num}</span>
                <span className="testi-stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Featured Testimonial Slider ── */}
      <section className="section-pad">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Success Stories</span>
            <h2 className="section-title">What Our Users Say</h2>
            <p className="section-sub">Real stories from professionals who found success with JobEntry</p>
          </div>

          <div className="featured-testi-wrap">
            <div className="featured-testi-slider">
              <Slider {...sliderSettings} afterChange={i => setFeatured(i)}>
                {testimonials.map((t, i) => (
                  <div key={i}>
                    <div className="featured-testi-card">
                      <div className="featured-testi-left">
                        <div className="featured-quote-icon">
                          <i className="fa fa-quote-left"></i>
                        </div>
                        <div className="featured-stars">
                          {[...Array(t.rating)].map((_, j) => <i key={j} className="fa fa-star"></i>)}
                        </div>
                        <p className="featured-testi-text">"{t.text}"</p>
                        <div className="featured-testi-tag">
                          <i className="fa fa-check-circle me-2"></i>{t.tag}
                        </div>
                        <div className="featured-testi-author">
                          <img src={t.img} alt={t.name} />
                          <div>
                            <strong>{t.name}</strong>
                            <span>{t.role} at {t.company}</span>
                          </div>
                        </div>
                      </div>
                      <div className="featured-testi-right">
                        <div className="featured-img-wrap">
                          <img src={t.img} alt={t.name} />
                          <div className="featured-img-badge">
                            <i className="fa fa-trophy"></i>
                            <span>Success Story</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            {/* Thumbnail Nav */}
            <div className="testi-thumbs">
              {testimonials.map((t, i) => (
                <div key={i} className={`testi-thumb ${featured === i ? 'active' : ''}`}>
                  <img src={t.img} alt={t.name} />
                  <div>
                    <strong>{t.name}</strong>
                    <span>{t.company}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── All Testimonials Grid ── */}
      <section className="section-pad bg-light-soft">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">All Reviews</span>
            <h2 className="section-title">Trusted by Thousands</h2>
            <p className="section-sub">Join the growing community of professionals who love JobEntry</p>
          </div>

          {/* Filter Tabs */}
          <div className="testi-filter-tabs">
            {filters.map((f, i) => (
              <button key={i} className={`testi-filter-btn ${active === i ? 'active' : ''}`} onClick={() => setActive(i)}>
                {f}
              </button>
            ))}
          </div>

          <div className="testi-grid-slider">
          <Slider {...gridSettings}>
            {testimonials.map((t, i) => (
              <div key={i} className="px-2">
                <div className="testi-grid-card">
                  <div className="testi-grid-top">
                    <div className="testi-grid-author">
                      <img src={t.img} alt={t.name} />
                      <div>
                        <strong>{t.name}</strong>
                        <span>{t.role}</span>
                      </div>
                    </div>
                    <div className="testi-grid-stars">
                      {[...Array(t.rating)].map((_, j) => <i key={j} className="fa fa-star"></i>)}
                    </div>
                  </div>
                  <p className="testi-grid-text">"{t.text}"</p>
                  <div className="testi-grid-footer">
                    <span className="testi-grid-tag">
                      <i className="fa fa-check-circle me-1"></i>{t.tag}
                    </span>
                    <span className="testi-grid-company">{t.company}</span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          </div>
        </div>
      </section>

      {/* ── Trusted Companies ── */}
      <section className="section-pad">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Our Partners</span>
            <h2 className="section-title">Trusted by Top Companies</h2>
            <p className="section-sub">Leading organizations rely on JobEntry to find their best talent</p>
          </div>
          <div className="testi-companies">
            {companies.map((logo, i) => (
              <div className="testi-company-logo" key={i}>
                <img src={logo} alt="" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-left">
              <h2>Ready to Write Your Success Story?</h2>
              <p>Join 120,000+ professionals who found their dream job through JobEntry.</p>
            </div>
            <div className="cta-right">
              <a href="/login" className="cta-btn-white">Get Started Free</a>
              <a href="/job-list" className="cta-btn-outline">Browse Jobs</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
